import { hFetch } from './hFetch';

export const createPhoneNumber = async (areaCode: string) => {
  const payload = {
    phone_number: {
      area_code: areaCode,
    },
  };

  return await hFetch({ url: '/api/phone_numbers', method: 'POST', payload });
};

export const getFacebookAdConfig = async () => {
  return await hFetch<HResponse<FacebookAdConfig>>({ url: '/api/quickstart/facebook_advertising_configuration' });
};

type UpdateFacebookAdConfigArgs = {
  facebookAdConfig?: FacebookAdConfig;
  teamPhotos?: FileList;
};
export const updateFacebookAdConfig = async ({ facebookAdConfig, teamPhotos }: UpdateFacebookAdConfigArgs) => {
  const formData = new FormData();
  formData.append('facebook_advertising_configuration[some_value]', 'true');

  if (teamPhotos && teamPhotos.length > 0) {
    for (let i = 0; i < teamPhotos.length; i++) {
      formData.append('team_photos[]', teamPhotos[i], teamPhotos[i].name);
    }
  }
  if (facebookAdConfig?.status) formData.append('facebook_advertising_configuration[status]', facebookAdConfig.status);
  return (await hFetch({
    url: '/api/quickstart/facebook_advertising_configuration',
    method: 'PUT',
    payload: formData,
  })) as HResponse<FacebookAdConfig>;
};

export type HResponse<T> = {
  record: T;
  status: 'success' | 'error';
  message?: string;
};

export type FacebookAdConfig = {
  id: number;
  team_id: number;
  form_id: string | null;
  status: 'inactive' | 'active' | 'not_started' | 'pending';
  error: string | null;
  ['team_photos?']: boolean | null;
  created_at: string;
  updated_at: string;
};
